import React from 'react'

export const AppleIcon = () => (
  <svg
    id="a55821e7-892d-42b8-905e-df36c4dc20bb"
    dataname="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20.88 25.28"
  >
    <path
      fill="#1d70b7"
      id="a9bcbafc-912b-429f-b603-c62f3e3a7f59"
      dataname="apple"
      className="f51c6c8a-08a0-4753-9da2-55e10b4ec888"
      d="M20.88,19.48a16,16,0,0,1-1.58,2.64c-1,1.4-2.47,3.14-4.26,3.16-1.59,0-2-.93-4.16-.92s-2.61.93-4.2.92c-1.79,0-3.16-1.59-4.19-3C-.37,18.38-.67,13.78,1.1,11.35A6.46,6.46,0,0,1,6.2,8.6c1.9,0,3.09.93,4.66.93s2.45-.93,4.64-.93a6.44,6.44,0,0,1,4.67,2.2c-4.1,2-3.44,7.27.71,8.68ZM14.23,5.08A6.86,6.86,0,0,0,15.74,0,7.41,7.41,0,0,0,11,2.57,6.41,6.41,0,0,0,9.4,7.52,6.27,6.27,0,0,0,14.23,5.08Z"
    />
  </svg>
)

export const AndroidIcon = () => (
  <svg
    id="f2fd40a4-0b3f-4dba-ad01-ef1f000d6539"
    dataname="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20.34 25.94"
  >
    <path
      id="signup_android_svg"
      dataname="android"
      d="M1.48,17.14h0A1.48,1.48,0,0,1,0,15.66H0V9.14A1.48,1.48,0,0,1,1.48,7.66h0A1.48,1.48,0,0,1,3,9.14H3v6.52a1.47,1.47,0,0,1-1.47,1.48Zm17.38,0h0a1.48,1.48,0,0,1-1.48-1.48h0V9.14a1.48,1.48,0,0,1,1.48-1.48h0a1.48,1.48,0,0,1,1.48,1.48v6.52a1.48,1.48,0,0,1-1.48,1.48ZM3.56,7V19.42a1.15,1.15,0,0,0,1.1,1.19h1.1v3.85a1.38,1.38,0,1,0,2.75.2.67.67,0,0,0,0-.2V20.61h3.31v3.85a1.38,1.38,0,1,0,2.75.2.67.67,0,0,0,0-.2V20.61h1.1a1.15,1.15,0,0,0,1.1-1.19V7ZM13.4,2.05,14.53.48a.31.31,0,0,0-.06-.42.27.27,0,0,0-.37,0v0L12.9,1.78a6.1,6.1,0,0,0-5.46,0L6.25.12A.26.26,0,0,0,5.89.05h0a.3.3,0,0,0,0,.42L6.94,2.05A7.15,7.15,0,0,0,3.59,7.66H16.75A7.17,7.17,0,0,0,13.4,2.05ZM7.08,3.51a.89.89,0,1,1-.89.89A.89.89,0,0,1,7.08,3.51Zm6.18,0a.89.89,0,1,1-.89.89A.89.89,0,0,1,13.26,3.51Z"
    />
  </svg>
)
